// TODO EKP-28256
import type { IntlShape } from 'react-intl';

import { matchPath as DEPRECATED_matchPath, matchPath } from 'react-router';

import { SearchQuery } from '~/features/advanced-search/types';
import { FolderTree } from '~/types/FolderTree';
// eslint-disable-next-line no-restricted-imports -- pre-existing usage unrelated to this change; EDS migration is separate scope
import { findFolder } from '~/ui/components/FolderTree/util';

import type { EntityContextItem } from '../types/chatbot';

export const DEFAULT_SEARCH_ID = 'evisort-search';
export const DEFAULT_DOCUMENTS_ID = 'ask-anything-documents-id';
export const getDefaultChatContext = (intl: IntlShape): EntityContextItem => ({
  query: [],
  selectedIds: [],
  label: intl.formatMessage({
    id: 'Utils.allDocumentsLabel',
    defaultMessage: 'All Documents',
    description: 'Label for all documents context',
  }),
  title: intl.formatMessage({
    id: 'Utils.allDocumentsTitle',
    defaultMessage: 'All Documents',
    description: 'Title for all documents context',
  }),
  icon: 'field-folder',
  searchEntity: 'document',
  id: DEFAULT_DOCUMENTS_ID,
  type: 'all_documents',
});

export const ROUTES = {
  folder: '/documents/:id',
  document: '/document/:id',
  dashboard: '/dashboards/:id',
  search: '/search',
  savedSearch: '/search/:id',
  documentGroupDetail: '/documents/entity-types/:entityTypeId/entities/:id',
  reviewerPage: '/workflow/tickets/:id/reviewer/:versionNumber',
  ticketViewPage: '/workflow/tickets/:id',
  requestsViewPage: '/workflows/requests/:id',
  xRay: 'automation/fields/:id',
};

export const pathMatch = (pathname: string, pattern: string) =>
  (
    DEPRECATED_matchPath({ path: pattern, end: false }, pathname) as {
      params: { id?: string };
    } | null
  )?.params.id;

export const getFolderContext = (
  folderId: number,
  folderTree?: FolderTree,
  primary?: boolean,
  intl?: IntlShape,
) => {
  const folder = findFolder(folderId, (folderTree?.children as any) ?? []);
  if (!folder) return undefined;
  if (folder) {
    const context: EntityContextItem = {
      label:
        intl?.formatMessage({
          id: 'Utils.thisFolderLabel',
          defaultMessage: 'This Folder',
          description: 'Label for current folder context',
        }) ?? '',
      query: getFolderQuery(folderId),
      title: folder.name,
      icon: 'field-folder',
      primary,
      searchEntity: 'document',
      selectedIds: [],
      id: folderId.toString(),
      type: 'folder',
    };
    return context;
  }
};

export const testIsInADocViewerPage = (pathname: string) => {
  return (
    matchPath(ROUTES.document, pathname) ||
    matchPath(ROUTES.reviewerPage, pathname)
  );
};

// This is currently only used by useDocumentStatusChecker, so we don't add CLMe Requests route here
// as we don't want to wait for document status checks
export const testIsPreSig = (pathname: string) => {
  return (
    matchPath(ROUTES.ticketViewPage, pathname) ||
    matchPath(ROUTES.reviewerPage, pathname)
  );
};

export const testPageHasSidebar = (pathname: string) => {
  return (
    matchPath(ROUTES.ticketViewPage, pathname) ||
    matchPath(ROUTES.reviewerPage, pathname) ||
    matchPath(ROUTES.document, pathname)
  );
};

export const getFolderQuery = (folderId: number) => {
  if (!folderId) return [];
  return [
    {
      type: 'filter',
      id: 'folder',
      operator: 'in_folder',
      value: { value_list: [folderId], value_meta: {} },
    },
  ] as SearchQuery;
};

export const getDocumentGroupQuery = (groupId: string) => {
  if (!groupId) return [];
  return [
    {
      type: 'filter',
      id: 'document_group_id',
      operator: 'contains_any',
      value: {
        value_list: [groupId],
        value_meta: {
          multi_select_data: {
            is_all_selected: false,
            length: 1,
            search: '',
            selected_values_map: { [groupId]: true },
          },
        },
      },
    },
  ] as SearchQuery;
};

export const getGroupQuery = (groupIds: string[]) => {
  if (!groupIds.length) return [];
  return [
    {
      type: 'filter',
      id: 'document_groups_Document',
      operator: 'contains_any',
      value: {
        value_list: groupIds,
        value_meta: {
          multi_select_data: {
            is_all_selected: false,
            length: groupIds.length,
            search: '',
            selected_values_map: Object.fromEntries(
              groupIds.map((id) => [id, true]),
            ),
          },
        },
      },
    },
  ] as SearchQuery;
};
